import styled, { CSSObject } from '@emotion/styled'
import { cssSetColorOpacity } from 'shop/theme/helpers'
import { StyledHTMLElement } from 'shop/theme/types'

const sharedMarkerStyle: CSSObject = {
  position: 'relative',
  zIndex: 10,
  padding: '4px',
  borderRadius: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden'
}

export const StoreMarker = styled.div<
  StyledHTMLElement & {
    isClickable?: boolean
    size?: string
    isCurrentlyViewed?: boolean
    isCurrentlyHovered?: boolean
  }
>(
  ({
    theme,
    isClickable = true,
    size = '40px',
    isCurrentlyViewed = false,
    isCurrentlyHovered = false
  }): CSSObject => ({
    ...sharedMarkerStyle,
    cursor: isClickable ? 'pointer' : 'inherit',
    width: size,
    height: size,
    background: '#fff',
    border: '2px solid',
    borderColor: theme.colors.primary,
    scale: isCurrentlyHovered || isCurrentlyViewed ? 1.2 : 1,
    boxShadow: isCurrentlyViewed
      ? `0 0 0 5px ${cssSetColorOpacity(theme.colors.primary, 90)}`
      : 'none'
  })
)

export const StoreIcon = styled.img(
  (): CSSObject => ({
    width: '100%',
    maxWidth: '100%',
    position: 'relative'
  })
)

export const UserLocationMarker = styled.div<
  StyledHTMLElement & { isClickable?: boolean }
>(
  ({ theme, isClickable = false }): CSSObject => ({
    ...sharedMarkerStyle,
    cursor: isClickable ? 'pointer' : 'inherit',
    width: '32px',
    height: '32px',
    background: cssSetColorOpacity(theme.colors.primary, 90),
    border: 'none'
  })
)
